export default [
  {
    path: '/churn-request',
    name: 'churn-request',
    component: () => import('@/views/pages/komtim/churn-request/List.vue'),
    meta: {
      name: 'Churn Request',
      resource: 'Komtim - Churn Request',
      action: 'manage',
      routeDetail: 'churn-request-detail',
    },
  },
  {
    path: '/churn-request/detail/:id',
    name: 'churn-request-detail',
    component: () => import('@/views/pages/komtim/churn-request/detail/Detail.vue'),
    meta: {
      name: 'Detail Churn Request',
      navActiveLink: 'churn-request',
      resource: 'Komtim - Churn Request',
      action: 'manage',
    },
  },
]
